import { Button } from 'foundations-components/transitional/components/Button';
import { Link } from 'foundations-components/transitional/components/Link';
import { Small } from 'foundations-components/transitional/components/Small';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { useCallback } from 'react';
import { useCardContext } from '../../context/CardContext';
import { usageTracker } from '../../utils/usageTracker';
import { jsx as _jsx } from "react/jsx-runtime";
const CardFooterAction = ({
  actionConfig,
  toObjectTypeId,
  usageTracker: legacyUsageTracker,
  use = 'button',
  variant = 'primary'
}) => {
  const {
    fromObjectTypeId
  } = useCardContext();
  const {
    disabled,
    external,
    href,
    label,
    onClick,
    disabledTooltipText
  } = actionConfig;
  const handleClickWithTracking = useCallback(() => {
    legacyUsageTracker === null || legacyUsageTracker === void 0 || legacyUsageTracker.track('sidebar-interaction', {
      type: toObjectTypeId,
      action: `Association card ${variant} action`
    });
    usageTracker.track('CRM', 'Record Interactions', {
      type: 'Association Card',
      action: 'Association card footer primary action',
      subAction: 'Clicked On View All Associated Objects',
      toObjectTypeId,
      fromObjectTypeId
    });
    onClick === null || onClick === void 0 || onClick();
  }, [onClick, toObjectTypeId, fromObjectTypeId, legacyUsageTracker, variant]);
  const actionElement = use === 'link' ? /*#__PURE__*/_jsx(Small, {
    children: /*#__PURE__*/_jsx(Link, {
      "data-test-id": `card-footer-${variant}-action`,
      disabled: disabled,
      external: external,
      href: href,
      onClick: handleClickWithTracking,
      truncate: true,
      children: label
    })
  }) : /*#__PURE__*/_jsx(Button, {
    "data-test-id": `card-footer-${variant}-action`,
    disabled: disabled,
    external: external,
    href: href,
    onClick: handleClickWithTracking,
    size: 'xs',
    use: 'tertiary-extra-light',
    children: label
  });
  if (disabledTooltipText) {
    return /*#__PURE__*/_jsx(Tooltip, {
      title: disabledTooltipText,
      children: actionElement
    });
  }
  return actionElement;
};
export default CardFooterAction;